import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import { AMDashboardService } from '@/modules/amDashboard/services';
import * as AT from './actionTypes';
import * as MT from './mutationsTypes';
import {
  OrgSubmissionsRequest,
  OrganisationClientRequest
} from '@/modules/amDashboard/types';
import { SET_LOADER } from '../../organisation/store/mutationTypes';
import { PensionScheme } from '../../pensionScheme/types';
import { IForecastState } from './state';
import { AggregatedForecastItem, PaginatedForecastResult } from '../types';
import { ForecastService } from '../service';
/**
 * --------------------------------------------------
 *  Forecast Actions
 * --------------------------------------------------
 **/
export const ForecastActions: IForecastActions = {
  [AT.FETCH_FORECAST]: (
    { commit },
    orgSubmissionsRequest: OrgSubmissionsRequest
  ): Promise<PaginatedForecastResult> => {
    commit(SET_LOADER, true);
    const request = {
      ...orgSubmissionsRequest,
      requestType: 'forecast'
    };
    return AMDashboardService.getSubmissionRequests(request).then(
      (paginatedResult: PaginatedForecastResult) => {
        commit(MT.SET_FORECAST, paginatedResult);
        commit(SET_LOADER, false);
        return paginatedResult;
      }
    );
  },
  [AT.FETCH_ORGANISATION_CLIENTS]: (
    { commit },
    params: OrganisationClientRequest
  ): Promise<PensionScheme[]> => {
    commit(SET_LOADER, true);
    return AMDashboardService.getOrganizationClients(params).then(
      (organizationClients: PensionScheme[]) => {
        commit(MT.SET_ORGANISATION_CLIENTS, organizationClients);
        commit(SET_LOADER, false);
        return organizationClients;
      }
    );
  },
  [AT.FETCH_FORECAST_AGGREGATE_DETAILS]: (
    { commit },
    organizationId: string
  ): Promise<AggregatedForecastItem[]> => {
    commit(SET_LOADER, true);
    return ForecastService.fetchForecastAggregateDetails(organizationId).then(
      (forecastAggregateDetails: AggregatedForecastItem[]) => {
        commit(MT.SET_AGGREGATED_FORECAST_DETAILS, forecastAggregateDetails);
        commit(SET_LOADER, false);
        return forecastAggregateDetails;
      }
    );
  }
};

/**
 * --------------------------------------------------
 *  Dashboard Action Context Interface
 * --------------------------------------------------
 **/
export interface IForecastActionContext
  extends ActionContext<IForecastState, IRootState> {}

/**
 * --------------------------------------------------
 *  Forecast Actions Interface
 * --------------------------------------------------
 **/
export interface IForecastActions
  extends ActionTree<IForecastState, IRootState> {
  [AT.FETCH_FORECAST](
    context: IForecastActionContext,
    orgSubmissionsRequest: OrgSubmissionsRequest
  ): Promise<PaginatedForecastResult>;
  [AT.FETCH_ORGANISATION_CLIENTS](
    context: IForecastActionContext,
    params: OrganisationClientRequest
  ): Promise<PensionScheme[]>;
  [AT.FETCH_FORECAST_AGGREGATE_DETAILS](
    context: IForecastActionContext,
    organizationId: string
  ): Promise<AggregatedForecastItem[]>;
}
